import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  FormGroup,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { IonInput } from '@ionic/angular/standalone';
import { REGEX_PATTERNS, SpecialCharacters } from 'src/app/core/enums';
import {
  onChangeType,
  onTouchType,
} from 'src/app/core/models/common/custom.component.model';
import { CommonUtils } from 'src/app/core/utils/common/common.utils';
import { VALIDATION_MESSAGE } from '../../../shared-constants';

@Component({
  selector: 'app-form-text-field',
  templateUrl: './form-text-field.component.html',
  styleUrls: ['./form-text-field.component.scss'],
  imports: [IonInput, FormsModule, ReactiveFormsModule, CommonModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormTextFieldComponent),
      multi: true,
    },
  ],
})
export class FormTextFieldComponent<T> implements ControlValueAccessor, OnInit {
  @Input() labelText!: string;
  @Input() maxLength!: number;
  @Input() minLength!: number;
  @Input() form!: FormGroup;
  @Input() control!: string;
  @Input() imageSrc = '';
  @Input() regexType = SpecialCharacters.NO_RESTRICTIONS;
  @Input() clearOnEdit = false;
  @Input() placeholderText = '';
  @Input() invalidPatternMessage: string = VALIDATION_MESSAGE.INVALID_EMAIL;
  @Input() hasRequiredSign = true;
  @Input() isItalicLabel = false;
  @Input() autoCapitalizeCharacters = false;
  @Input() readonly = false;
  @Input() biggerText = false;
  @Input() type = 'text';
  @Input() requiredErrorMessage = VALIDATION_MESSAGE.REQUIRED;
  @Input() pasteRegexType = 'none';

  required = true;

  readonly ERROR_CONSTANTS = VALIDATION_MESSAGE;
  readonly RegexType = REGEX_PATTERNS;

  onChange: onChangeType = () => {};
  onTouch: onTouchType = () => {};
  writeValueObj!: T;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setDisabledStateFn: unknown = () => {};

  constructor(readonly commonUtils: CommonUtils) {}
  ngOnInit(): void {
    const controlRef = this.form?.get(this.control);
    const validatorFns = controlRef?.validator
      ? controlRef.validator({} as AbstractControl)
      : null;
    this.required =
      this.hasRequiredSign &&
      !!validatorFns &&
      Object.keys(validatorFns).includes('required');
  }

  registerOnChange(fn: onChangeType): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: onTouchType): void {
    this.onTouch = fn;
  }

  writeValue(obj: T): void {
    this.form.get(this.control)?.setValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.setDisabledStateFn = isDisabled;
  }

  preventSpecialCharacters($event: KeyboardEvent) {
    this.commonUtils.preventSpecialCharacters($event, this.regexType);
  }
}
